export default function (props: any) {
    return (
        <svg width="209px" height="74px" viewBox="0 0 209 74" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="M端" transform="translate(-19.000000, -832.000000)" stroke="#2091FF" strokeWidth="3">
                    <g id="编组-15" transform="translate(0.000000, 834.000000)">
                        <path
                            d="M74.5808857,55.5285193 C39.1913832,48.9356767 25.7873265,38.7663543 34.3687157,25.020552 C40.5553041,15.1107789 59.3133275,6.21495192 90.7710879,1.77056469 C122.228848,-2.67382254 162.738299,1.77056469 188.480116,9.30563019 C236.801403,27.1404039 232.359789,53.418118 207.272049,62.4764442 C180.838934,72.0540288 58.687561,78.2917873 21.0559511,43.6971617"
                            id="路径备份"
                            transform="translate(123.363643, 35.000000) scale(-1, 1) translate(-123.363643, -35.000000) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
